import { Box, Grid, Typography } from "@mui/material";
import { LICENSE_CODE_TO_DATA_MAP } from "Components/Licenses/licenseUtils";
import type { LicenseCode } from "Infrastructure/Api/Api";

type Props = {
  code: string;
  licenseNo?: string | null;
};

export const LicenseCard = ({ code, licenseNo }: Props) => {
  const licenseData = LICENSE_CODE_TO_DATA_MAP[code as LicenseCode];
  const imageSrc = licenseData?.czImg;

  return (
    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
      <Box
        display="flex"
        alignItems="stretch"
        border="1px solid"
        borderColor="divider"
        borderRadius={2}
        overflow="hidden"
        gap={2}
      >
        {imageSrc && (
          <Box
            sx={{
              width: 100,
              minWidth: 100,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
            }}
          >
            <Box
              component="img"
              src={imageSrc}
              alt={code}
              sx={{
                width: "100%",
                height: 70,
                objectFit: "cover",
              }}
            />
          </Box>
        )}
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          p={1.5}
        >
          <Typography fontWeight={600} fontSize={18}>
            {code}
          </Typography>
          <Typography fontSize={14} color="text.secondary">
            {licenseNo ? `#${licenseNo}` : "???"}
          </Typography>
        </Box>
      </Box>
    </Grid>
  );
};
